import React from "react";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";

const CloseButton = ({ translate, closeClickHandler }) => {
  const theme = useTheme();
  return (
    <div className="dis-flex">
      <VideoPlayerButtonComponent
        src={process.env.PUBLIC_URL + "/images/playback-close.svg"}
        alt={translate("close")}
        onClickHandler={closeClickHandler}
        tooltipDirection="bottom"
        buttonClassName="playbackClose"
        $hoverBackgroundColor={theme.colours.mineShaftGray}
      />
    </div>
  );
};

export default CloseButton;
